'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isCanadianPostalCode = exports.isZip = exports.isMatch = undefined;

var _ramda = require('ramda');

var canadian = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/mgi;
var zip = /^\d{5}(-?\d{4})?$/gm;

var isMatch = exports.isMatch = function isMatch(re, value) {
	if (value && value.toString().match(re)) {
		return true;
	}

	return false;
};

var isZip = exports.isZip = (0, _ramda.partial)(isMatch, [zip]);
var isCanadianPostalCode = exports.isCanadianPostalCode = (0, _ramda.partial)(isMatch, [canadian]);

exports.default = {
	isZip: isZip,
	isCanadianPostalCode: isCanadianPostalCode
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMValidatingTextField/isPostalCode.js